<template>
  <div class="content">
    请选择左侧需要修改的内容~
  </div>
</template>
<script>

export default {
  data() {
    return {

    };
  },
  components: {

  },
  methods: {

  },

};
</script>

<style lang="less" scoped>
.content {
  height: ~"calc(100vh - 120px)";
  overflow: auto;
  background: #fff;
  box-shadow: 0px 2px 6px 1px rgba(56, 132, 194, 0.1);
  padding: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/websiteDetail.vue